import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { CheckToken } from "./AccessToken";

const PermissionContext = createContext();

export const PermissionProvider = ({ children }) => {
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userInfo, setUserInfo] = useState(null);

  const fetchPermissions = async () => {
    setLoading(true);
    try {
      const token = sessionStorage.getItem("accessToken");
      if (!token || !CheckToken()) {
        setPermissions([]);
        setLoading(false);
        setUserInfo(null);
        return;
      }

      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_ROUTE_URL}get_logged_in_user_info/`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data.status === "Success") {
        setPermissions(res.data.role_permission?.[0]?.permissions || []);
        setUserInfo(res.data);
      } else {
        setPermissions([]);
        setUserInfo(null);
      }
    } catch (err) {
      console.error("Error fetching permissions", err);
      setPermissions([]);
      setUserInfo(null);
    }
    setLoading(false);
  };

  // fetch once when app mounts
  useEffect(() => {
    fetchPermissions();
  }, []);

  return (
    <PermissionContext.Provider
      value={{
        permissions,
        userInfo,
        loading,
        refreshPermissions: fetchPermissions,
      }}
    >
      {children}
    </PermissionContext.Provider>
  );
};

export const usePermissions = () => useContext(PermissionContext);
